<template>
  <div>
    <transition name="fade">
      <div
        v-if="open"
        class="overlay"
        @click="closeMenu"
      ></div>
    </transition>

    <transition name="slide">
      <aside
        v-if="open"
        class="menu"
      >
        <div class="menu-header">
          <h2>{{ isLogado ? auth.user?.nome : "Usuário não autenticado" }}</h2>
        </div>

        <div class="menu-items">
          <button
            class="menu-item menu-item-perfil"
            v-if="isLogado"
            @click="abrirPerfil"
          >
            <span>Visualizar perfil</span>
            <span
              v-if="auth.perfilIncompleto"
              class="badge-menu-incompleto"
              title="Faltam algumas informações no seu perfil"
            >
              ? Atualizar
            </span>
          </button>
          <button
            class="menu-item"
            v-if="isLogado && isUsuarioPrex"
            @click="abrirCentralPrex"
          >
            Área PREX
          </button>
          <button
            class="menu-item"
            v-if="isLogado && isCoordenadorDeUnidade"
            @click="abrirCentralUnidade"
          >
            Área da Unidade
          </button>
          <button
            class="menu-item"
            v-if="isLogado && auth.hasRole('ADMINISTRADOR')"
            @click="abrirEdicaoPerfil"
          >
            Editar usuários
          </button>
          <button
            class="menu-item"
            v-if="isLogado && auth.hasRole('ADMINISTRADOR')"
            @click="abrirGestaoTermos"
          >
            Gestão de Termos
          </button>

          <button
            class="menu-item"
            :class="{ 'btn-login': !isLogado, 'btn-logout': isLogado }"
            @click="handleAuthAction"
          >
            {{ isLogado ? "Sair" : "Entrar no GEX" }}
          </button>
        </div>
      </aside>
    </transition>
  </div>
</template>

<script setup>
import { ref, defineExpose, defineEmits, computed } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import { storeToRefs } from "pinia";
const open = ref(false);
const router = useRouter();
const emit = defineEmits(["fechou"]);
const auth = useAuthStore();

const { isAutenticado, estaRenovando } = storeToRefs(auth);

const isLogado = computed(() => isAutenticado.value || estaRenovando.value);
const isUsuarioPrex = computed(() => isLogado.value && auth.hasRole("PREX"));
// Coordenador de UNIDADE = regra COORDENADORIA (diferente de SCOPE_COORDENADOR, de ação)
const isCoordenadorDeUnidade = computed(
  () => isLogado.value && auth.hasRole("COORDENADORIA")
);

function openMenu() {
  open.value = true;
}

function handleAuthAction() {
  if (isLogado.value) {
    auth.finalizarSessao();
    router.push("/");
  } else {
    router.push({ name: "login" });
  }
  closeMenu();
}

function abrirCentralPrex() {
  router.push("/central-prex");
  closeMenu();
}

function abrirCentralUnidade() {
  router.push("/central-unidade");
  closeMenu();
}

function abrirEdicaoPerfil() {
  router.push("/lista-usuarios");
  closeMenu();
}

function abrirGestaoTermos() {
  router.push("/admin/termos");
  closeMenu();
}

function abrirPerfil() {
  router.push("/perfil");
  closeMenu();
}

function closeMenu() {
  open.value = false;
  emit("fechou");
}

defineExpose({
  openMenu,
  closeMenu,
});
</script>
<style scoped>
/* Fundo escuro */
.overlay {
  position: fixed;
  inset: 0;
  background: hsla(0, 0%, 0%, 0.35);
  z-index: 40;
}

.btn-login {
  background-color: var(--branco) !important;
  color: var(--roxo-primario) !important;
  box-shadow: 0 2px 4px hsla(0, 0%, 0%, 0.1);
}

.btn-login:hover {
  background-color: var(--roxo-superficie) !important;
  color: var(--roxo-primario) !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px hsla(0, 0%, 0%, 0.15);
}

.btn-login:active {
  transform: translateY(0);
}

.btn-logout {
  background-color: var(--vermelho) !important;
  color: var(--branco) !important;
}

.btn-logout:hover {
  background-color: var(--vermelho) !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 8px hsla(0, 0%, 0%, 0.2);
}

.btn-logout:active {
  transform: translateY(0);
}

/* Menu */
.menu {
  position: fixed;
  right: 0;
  top: 90px;
  height: calc(100svh - 90px);
  width: 260px;
  background-color: var(--roxo-primario);
  color: var(--branco);
  z-index: 200;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  font-family:
    "Inter",
    system-ui,
    -apple-system,
    "Segoe UI",
    Roboto,
    Helvetica,
    Arial,
    sans-serif;
}

/* Cabeçalho */
.menu-header {
  margin-bottom: 30px;
}

.menu-header h2 {
  font-size: 20px;
  font-weight: 600;
  font-family: inherit;
}

/* Itens */
.menu-items {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.menu-item {
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  background: hsla(0, 0%, 100%, 0.1);
  border: none;
  padding: 12px;
  border-radius: 8px;
  color: var(--branco);
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  width: 100%;
  text-align: center;
}

.menu-item:hover {
  background: hsla(0, 0%, 100%, 0.2);
}

.menu-item-perfil {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.badge-menu-incompleto {
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  border-radius: 999px;
  background-color: hsl(32, 95%, 52%);
  color: hsl(0, 0%, 100%);
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

/* Animações */

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-enter-from,
.slide-leave-to {
  transform: translateX(100%);
}
@media (max-width: 768px) {
  .menu {
    top: 70px;
    height: calc(100svh - 70px);
  }
}
</style>
